import { render, staticRenderFns } from "./SendDocumentDetail.vue?vue&type=template&id=419495f4&"
import script from "./SendDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./SendDocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports